import { booleanAttribute, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[coreUiMousePosition]',
    standalone: false
})
export class MousePositionDirective {
    @Input({ alias: 'coreUiMousePosition', transform: booleanAttribute }) enabled = true;

    constructor(private el: ElementRef<HTMLElement>) {}

    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent): void {
        if (!this.enabled || this.isDisabledViewport) {
            this.resetMousePosition();
            return;
        }

        const element = this.el.nativeElement;
        const rect = element.getBoundingClientRect();

        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        element.style.setProperty('--x', `${x}px`);
        element.style.setProperty('--y', `${y}px`);
        element.classList.add('is-mouse-positioned');
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        this.resetMousePosition();
    }

    private get isDisabledViewport(): boolean {
        return typeof window !== 'undefined'
            && window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
    }

    private resetMousePosition(): void {
        const element = this.el.nativeElement;

        element.classList.remove('is-mouse-positioned');
    }

}
